import { useRequest } from '@10000/react'
import { CreditCard } from '../../forms'
import { Box } from '../../widgets'
import { SettingsForm } from '../'

export const UpdateCard = ({ onClose }) => {
  const request = useRequest('tenant')

  const onSubmit = details => request('paymentMethodUpdated', details).then(onClose)

  return (
    <SettingsForm
      onSubmit={onSubmit}
      title="Update"
      onBackButtonClick={onClose}
    >
      <Box pt={32}>
        <CreditCard name="cardDetails" dark />
      </Box>
    </SettingsForm>
  )
}